import React from 'react';
import classNames from 'classnames';
import SectionHeader from './partials/SectionHeader';

const PrivacyContent = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    'testimonial section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'testimonial-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames('tiles-wrap', pushLeft && 'push-left');

  const sectionHeader = {
    title: 'Privacy Policy',
    paragraph: ''
  };

  return (
    <section {...props} className={outerClasses}>
      <div className='container'>
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className='center-content' tag='h1' />
          <p className='text-sm mb-32'>
            Keep Me Out as a free application which is ad-supported with an
            in-app purchases to remove ads from app. This Service is provided by
            Vikesh Dass at almost no cost and is intended for use as is. If you
            choose to use these Service, then you agree to the policies defined
            here. I will not use or share your information with anyone except as
            described in this Privacy Policy.
          </p>
          <h4 className='mt-0 mb-16'>Information Collection and Usage</h4>
          <p className='text-sm mb-32'>
            For a better experience while using these Service, Keep Me Out may
            require you to provide Read Contacts permission which will only be
            used to read user's contacts so as to allow user to make an
            emergency call while the Keep Me Out Service for device lock is
            running. Keep me out doesn't store these contacts anywhere
            permanently neither does it upload this information anywhere. Its
            strictly fetched while the application runs and is cleared as soon
            as the user exits the application Please note this app does use
            third party services that may collect information used to identify
            you.
          </p>
          <h4 className='mt-0 mb-16'>
            Third party Service Providers used in this application
          </h4>
          <p className='text-sm mb-32'>
            To assist in analyzing how the Services are being used and which
            areas need improvement : Google Analytics and Messaging. To serve
            advertisement : Google ads
          </p>
          <h4 className='mt-0 mb-16'>
            Web Dashboard &mdash; optional data sync (opt-in only)
          </h4>
          <p className='text-sm mb-32'>
            Keep Me Out includes an <strong>optional</strong> Web Dashboard that
            lets you view your own focus trends &mdash; your streaks, focused
            time, completed locks and urges resisted &mdash; in any web browser.
            This feature is <strong>strictly opt-in and is OFF by default</strong>.
            Nothing about your usage leaves your phone unless you explicitly
            connect the Web Dashboard from inside the app. If you never connect
            it, your data continues to stay only on your device, exactly as
            before.
          </p>
          <p className='text-sm mb-32'>
            <strong>What is synced when you opt in:</strong> only the data that
            powers your dashboard &mdash; your lock/focus sessions (start time,
            duration and whether they completed), the number of times you
            resisted opening your phone, your subscription status (so premium
            features work in the browser), and the timestamp and time zone of
            each event so the trends line up with your day. <strong>What is
            never synced:</strong> your contacts, messages, the content of any
            app, your browsing, your location, or any file &mdash; the Web
            Dashboard has no access to those.
          </p>
          <p className='text-sm mb-32'>
            <strong>We cannot see who you are.</strong> The Web Dashboard uses no
            account &mdash; there is no name, email, phone number or password. When
            you connect, your device is given a random, anonymous identifier that
            is <em>not</em> derived from your name, email, phone number, Google
            account, advertising ID or device serial. Your focus data is stored
            under that random ID on our secure servers (hosted on Amazon Web
            Services) and is encrypted in transit. We have no way to tie it back
            to your personal identity.
          </p>
          <p className='text-sm mb-32'>
            <strong>You stay in control.</strong> Before any data is sent, the app
            shows you exactly what will be synced and asks for your explicit
            consent &mdash; and it records that you agreed. You can disconnect at
            any time to stop syncing, and you can request deletion of your synced
            data by contacting us (see below).
          </p>
          <p className='text-sm mb-32'>
            <strong>Keeping your synced history.</strong> Because there is no
            account, your synced history is tied to the anonymous key held by the
            Keep Me Out app <em>on this phone</em>. To avoid losing that history,
            keep the app installed and avoid clearing its data or uninstalling it
            &mdash; a reinstall or a factory reset creates a fresh anonymous key,
            and previously synced data may no longer be reachable from the new
            install. (A savable recovery code that restores your history on a new
            phone is planned for a future update.)
          </p>
          <h4 className='mt-0 mb-16'>Changes to this Privacy Policy</h4>
          <p className='text-sm mb-32'>
            I may update these Privacy Policies from time to time. Thus, you are
            advised to review this page periodically for any changes. I will
            notify you of any changes by posting the new or updated Privacy
            Policies on this page. These changes are effective immediately,
            after they are posted on this page.
          </p>
          <h4 className='mt-0 mb-16'>Contact</h4>
          <p className='text-sm mb-32'>
            If you have any questions or comments about this Privacy Policy,
            please contact me at{' '}
            <a href='mailto:keepmeout.help@eudaitec.com'>
              keepmeout.help@eudaitec.com
            </a>{' '}
            or click 'Contact for support' within app options menu at the{' '}
            <a href='https://play.google.com/store/apps/details?id=vikesh.dass.lockmeout&hl=de&gl=US'>
              Keep Me Out Google Playstore page
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyContent;
